import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import { string, object } from 'yup';
import { post } from '../../Services/http';

const formschema = object().shape({
    firstName: string().required(translate(`validation.required`)),
    lastName: string().required(translate(`validation.required`)),
    phone: string().required(translate(`validation.required`)),
    companyName: string().required(translate(`validation.required`)),
    email: string()
        .required(translate(`validation.required`))
        .email(translate(`validation.emailInvalid`)),
    locality: string().required(translate(`validation.required`)),
});

export const Registration = ({ model }) => {
    const initialValues = {
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        companyName: '',
        locality: '',
        optInMarketInfo: false,
        OptInTechnicalInfo: false,
    };

    const [form, setForm] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState(null);

    const onChange = (propName, value) => {
        setForm((prevState) => ({
            ...prevState,
            [propName]: value,
        }));
    };

    const onSubmit = async () => {
        setErrors({});

        await formschema
            .validate(form, { abortEarly: false })
            .catch((error) => {
                const validationErrors = {};
                error.inner.forEach((e) => {
                    validationErrors[e.path] = e.message;
                });
                setErrors(validationErrors);
            });

        await post('/api/registration', form)
            .then((response) => response.json())
            .then((response) => {
                if (response.redirectUrl) {
                    window.location.replace(response.redirectUrl);
                }
                if (response.success) {
                    setMessage(translate('registration.block.success'));
                } else {
                    setMessage(translate('registration.block.failed'));
                }
            })
            .catch((ex) => {
                if (ex.response) {
                    ex.response.json().then((errors) => {
                        setErrors(errors);
                    });
                }
            });
    };

    return (
        <div className="newsletter__container">
            {message && (
                <div
                    className="message-overlay"
                    onClick={() => setMessage(null)}
                >
                    <div
                        className="message-box"
                        onClick={() => setMessage(null)}
                    >
                        <p>{message}</p>
                        <button
                            className="button secondary newsletter-button"
                            onClick={() => setMessage(null)}
                        >
                            {translate('registration.success.button')}
                        </button>
                    </div>
                </div>
            )}
            {(model.Title || model.Icon) && (
                <div className="newsletter__container--left">
                    {model.Icon && (
                        <img
                            className="newsletter__container--image"
                            src={model.Icon}
                            alt={model.IconAlt}
                        ></img>
                    )}
                    {model.Title && (
                        <div className="newsletter__container--title">
                            {model.Title}
                        </div>
                    )}
                    {model.Description && (
                        <div
                            className="newsletter__container--description"
                            dangerouslySetInnerHTML={{
                                __html: model.Description,
                            }}
                        ></div>
                    )}
                </div>
            )}
            <form
                className="newsletter__container--form"
                onSubmit={(e) => e.preventDefault()}
            >
                <div className="newsletter__container--form-row">
                    <div className="newsletter__container--field">
                        <label
                            className="newsletter__container--label"
                            htmlFor="firstName"
                        >
                            {translate('registration.block.firstname')} *
                            {errors.firstName && (
                                <span className="newsletter__container--error-message">
                                    {errors.firstName ?? errors.firstName[0]}
                                </span>
                            )}
                        </label>
                        <input
                            className={`newsletter__container--input ${
                                errors.firstName ? 'input-error' : ''
                            }`}
                            type="text"
                            id="firstName"
                            name="firstName"
                            onChange={(event) =>
                                onChange('firstName', event.target.value)
                            }
                        />
                    </div>

                    <div className="newsletter__container--field">
                        <label
                            className="newsletter__container--label"
                            htmlFor="lastName"
                        >
                            {translate('registration.block.lastname')} *
                            {errors.lastName && (
                                <span className="newsletter__container--error-message">
                                    {errors.lastName ?? errors.lastName[0]}
                                </span>
                            )}
                        </label>
                        <input
                            className={`newsletter__container--input ${
                                errors.lastName ? 'input-error' : ''
                            }`}
                            type="text"
                            id="lastName"
                            name="lastName"
                            onChange={(event) =>
                                onChange('lastName', event.target.value)
                            }
                        />
                    </div>
                </div>

                <div className="newsletter__container--form-row">
                    <div className="newsletter__container--field">
                        <label
                            className="newsletter__container--label"
                            htmlFor="email"
                        >
                            {translate('registration.block.email')} *
                            {errors.email && (
                                <span className="newsletter__container--error-message">
                                    {errors.email ?? errors.email[0]}
                                </span>
                            )}
                        </label>
                        <input
                            className={`newsletter__container--input ${
                                errors.email ? 'input-error' : ''
                            }`}
                            type="text"
                            id="email"
                            name="email"
                            onChange={(event) =>
                                onChange('email', event.target.value)
                            }
                        />
                    </div>

                    <div className="newsletter__container--field">
                        <label
                            className="newsletter__container--label"
                            htmlFor="phone"
                        >
                            {translate('registration.block.phone')} *
                            {errors.phone && (
                                <span className="newsletter__container--error-message">
                                    {errors.phone ?? errors.phone[0]}
                                </span>
                            )}
                        </label>
                        <input
                            className="newsletter__container--input"
                            type="text"
                            id="phone"
                            name="phone"
                            onChange={(event) =>
                                onChange('phone', event.target.value)
                            }
                        />
                    </div>
                </div>
                <div className="newsletter__container--form-row">
                    <div className="newsletter__container--field">
                        <label
                            className="newsletter__container--label"
                            htmlFor="company"
                        >
                            {translate('registration.block.company')} *
                            {errors.companyName && (
                                <span className="newsletter__container--error-message">
                                    {errors.companyName ??
                                        errors.companyName[0]}
                                </span>
                            )}
                        </label>
                        <input
                            className={`newsletter__container--input ${
                                errors.companyName ? 'input-error' : ''
                            }`}
                            type="text"
                            id="company"
                            name="company"
                            onChange={(event) =>
                                onChange('companyName', event.target.value)
                            }
                        />
                    </div>
                    <div className="newsletter__container--field">
                        <label
                            className="newsletter__container--label"
                            htmlFor="locality"
                        >
                            {translate('registration.block.locality')} *
                            {errors.locality && (
                                <span className="newsletter__container--error-message">
                                    {errors.locality ?? errors.locality[0]}
                                </span>
                            )}
                        </label>
                        <input
                            className={`newsletter__container--input ${
                                errors.locality ? 'input-error' : ''
                            }`}
                            type="text"
                            id="locality"
                            name="locality"
                            onChange={(event) =>
                                onChange('locality', event.target.value)
                            }
                        />
                    </div>
                </div>
                {model.UnderFormText != null && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: model.UnderFormText,
                        }}
                    ></div>
                )}
                <button
                    className="button secondary newsletter-button"
                    type="submit"
                    onClick={() => onSubmit()}
                >
                    {model.ButtonText == null ? '' : model.ButtonText}
                </button>
            </form>
        </div>
    );
};
